// 经营报表的状态文案与颜色（文档 18 §4：次级状态用色点，不用实底标签）。
import type { TurnoverStatus } from './types';

/** 周转状态：老系统 getTurnoverStatus —— ≤30 天高周转、>90 天偏慢、无出库单独一档 */
export const turnoverStatus: Record<TurnoverStatus, { label: string; dot: 'green' | 'blue' | 'amber' | 'grey' }> = {
  fast: { label: '高周转', dot: 'green' },
  normal: { label: '正常', dot: 'blue' },
  slow: { label: '偏慢', dot: 'amber' },
  'no-outbound': { label: '无出库', dot: 'grey' },
};

export const salesBasis: { value: string; label: string }[] = [
  { value: 'createdAt', label: '订单创建日' },
  { value: 'customerOrderDate', label: '客户下单日' },
  { value: 'deliveryDate', label: '交货期' },
];

export const purchaseBasis: { value: string; label: string }[] = [
  { value: 'orderDate', label: '采购日期' },
  { value: 'createdAt', label: '创建时间' },
  { value: 'expectedArrivalDate', label: '预计到货' },
];
